import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from "@angular/core";

/** A clickable card surface with selected/error states; content (title, description, ...) is caller-projected. */
@Component({
    selector: "app-cerrix-toggle-card",
    imports: [],
    templateUrl: "./cerrix-toggle-card.component.html",
    styleUrl: "./cerrix-toggle-card.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixToggleCardComponent {
    selected = input(false);
    ariaLabel = input<string | undefined>();
    clickEvent = output<void>();

    onClickHandler(): void {
        this.clickEvent.emit();
    }
}
